<template>
  <v-container fluid class="purchasereceipt-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" sm="12" md="12" lg="12" class="d-flex flex-start justify-md-start overflow-auto">
              <!-- <v-btn to="/purchasereceipt/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn> -->
              <!-- <v-btn color="success" class="button-shadow mr-3" @click="findPurchaseReceiptDialog=true">
                <v-icon class="mr-2">mdi-file-search</v-icon>
                Find
              </v-btn> -->
              <v-btn to="/purchaseorder/list" color="default" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-file-multiple</v-icon>
                Purchases
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              show-select
              sort-desc
              item-key="_id"
              loading-text="Loading... Please wait"
              class="purchasereceipts-table"
              sort-by="purchasereceiptnum"
              :loading="isReceiving || isDeleting"
              :footer-props="footer"
              :headers="headers"
              :items="purchasereceipts"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Purchase Recepit?
                    </v-card-title>
                    <v-card-text>
                      {{ deletepurchasereceipt.purchasereceiptnum }} 
                      {{ deletepurchasereceipt.purchasereceiptname }}
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(deletepurchasereceipt)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.transactions="{ item }">
                <p class="two-line">Qty: {{ item.transactions.reduce((partial_sum, tran) => parseFloat(partial_sum) + parseFloat(tran.receiveQty),0).toFixed(0) }}</p>
              </template>
              <template v-slot:item.purchasereceiptimage="{ item }">
                    <v-img
                    v-if="item.purchasereceiptimage" 
                    v-bind:src="item.purchasereceiptimage"
                    max-height="70"
                    max-width="70"
                  ></v-img>
              </template>
              <template v-slot:item.purchasereceiptnum="{ item }">
                
                <p class="two-line">{{ item.purchasereceipttype  }}</p>
                <p class="two-line">{{ item.purchasereceiptnum  }}</p>
                <p v-if="item.purchasereceiptdate!=undefined" class="two-line">{{ new Date(item.purchasereceiptdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}</p>
              </template>
              <template v-slot:item.purchasereceiptname="{ item }">
                <p class="two-line">{{ item.purchasereceiptname }}</p>
                <p class="two-line" v-if="item.locationid!=undefined">{{ locations.length>0 ? locations.find(location=>location._id == item.locationid)['locationname'] : ''  }}</p>
              </template>
              <template v-slot:item.purchasereceiptstatus="{ item }">
                <v-chip
                  v-if="item.purchasereceiptstatus!=undefined"
                  :color="
                  item.purchasereceiptstatus=='Completed' ? 'successConst white--text' : 
                  item.purchasereceiptstatus=='Partial' ? 'warning white--text' : 
                  item.purchasereceiptstatus=='New' ? 'primaryConst white--text' : 
                  'secondaryConst white--text'" 
                  small
                >
                  {{ item.purchasereceiptstatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <div v-if="item._id!=undefined">
                <!-- <v-btn icon color="primary" @click="viewItem(item)">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn> -->
                <!-- <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn> -->
                <v-btn icon color="primary" @click="printItem(item)">
                  <v-icon>mdi-printer</v-icon>
                </v-btn>
                <v-btn v-if="item.purchasereceiptstatus!=='Completed'" icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-dialog
        v-model="findPurchaseReceiptDialog"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Find Purchase Recepits</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>

              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="findPurchaseReceiptDialog = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="resetPurchaseReceipts"
            >
              Reset
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="findPurchaseReceipts"
            >
              Find
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import config from "../../../config"
import { mapState, mapActions } from 'vuex'

export default {
  name: 'PurchaseReceiptList',
  data() {
    return {
      config,
      snackbar: null,
      dialog: false,
      dialogAlert: false,
      dialogMessage: '',
      findPurchaseReceiptDialog: false,
      menu_startdate: null,
      menu_enddate: null,
      itemPerPage: 500,
      deletepurchasereceipt: {},
      query: {},
      footer: {'items-per-page-options': [500, 1000, 5000]},
      headers: [
        { text: 'Image', value: 'purchasereceiptimage', sortable: false, width: '8%' },
        { text: 'Receipt', value: 'purchasereceiptnum', sortable: false },
        { text: 'Name', value: 'purchasereceiptname' },
        { text: 'Received', value: 'transactions' },
        { text: 'Status', value: 'purchasereceiptstatus' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      dataOrders: [],
      dataSelected: [],

    }
  },
  computed: {
    ...mapState('PurchaseReceipt', ['purchasereceipts', 'isReceiving', 'isDeleting','purchasereceiptsMessage']),
    ...mapState('Location', ['locations']),
    ...mapState('User', ['users']),
  },
  methods: {
    ...mapActions('PurchaseReceipt', ["getPurchaseReceiptsRequest", "getPurchaseReceiptQueryRequest", "deletePurchaseReceiptRequest","updatePurchaseReceiptRequest","createPurchaseReceiptRequest"]),
    ...mapActions('Location', ["getLocationsRequest"]),
    ...mapActions('User', ["getUsersRequest"]),
    checkError(){
      if(this.dataSelected.length==0) return false;
      if(this.dataSelected.find(item=>item.purchasereceiptstatus=='Completed')!=null) return false;
      return true;
    },
    editItem(item) {
      this.$router.push({ name: 'PurchaseReceiptEdit', params: item });
    },
    printItem(item) {
      this.$router.push({ name: 'PurchaseReceiptPrint', params: item });
    },
    viewItem(item) {
      this.$router.push({ name: 'PurchaseReceiptView', params: item });
    },
    async findPurchaseReceipts(){
      this.findPurchaseReceiptDialog = false;
      if(this.query=={}){
        await this.getPurchaseReceiptsRequest();
        this.dataOrders = Object.assign([], this.purchasereceipts);
        this.dataOrders.push({purchasereceipttotal: this.purchasereceipts.reduce(function (last, json) {return last + json.purchasereceipttotal;}, 0) });
      }
      else{
        let result = await this.getPurchaseReceiptQueryRequest(this.query);
        this.dataOrders = Object.assign([], result);
        this.dataOrders.push({purchasereceipttotal: result.reduce(function (last, json) {return last + json.purchasereceipttotal;}, 0) });
      }
    },
    async resetPurchaseReceipts(){
      this.query = {};

    },
    async deleteItem(item) {
      await this.deletePurchaseReceiptRequest({_id: item._id});
      this.dataOrders = this.purchasereceipts;
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      this.deletepurchasereceipt = {
        _id: item._id,
        purchasereceiptnum: item.purchasereceiptnum,
        purchasereceiptname: item.purchasereceiptname,
      }
    },
  },
  async created () {
    if(this.purchasereceipts.length==0) await this.getPurchaseReceiptsRequest();
    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.users.length==0) await this.getUsersRequest();
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
